import {
    Injectable
  } from '@angular/core';
  import {
    Observable  } from 'rxjs';
  import {
    HttpClient
  } from "../utility/http.client";
  
  
  
  @Injectable()
  export class EventService {
  
    constructor(
      private http: HttpClient
    ) {}
  
    addEvent(data: any): Observable < any > {
      return this.http.post('/events/addEvent', data);
    }

    updateEvent(data: any): Observable < any > {
      return this.http.post('/events/updateEvent',data);
    }

    removeEvent(data: any): Observable < any > {
      return this.http.post('/events/removeEvent',data);
    }
    
     getEvents(data : any): Observable < any > {
       return this.http.get('/events/getEvents',data);      
     } 

    // updateCRMObj(data : any ): Observable < any > {
    //   ////console.log("data ",data)
    //   return this.http.post('/crm/updateCRMObj/',data);      
    // }  

    // checkEmail(data : any ): Observable < any > {
    //   //console.log("checking email ")
    //   return this.http.post('/crm/checkEmail/',data);            
    // }
  }
  